// extracted by mini-css-extract-plugin
module.exports = {"backgroundImageStyle":"styles_backgroundImageStyle__3Zhwz","newsButton":"styles_newsButton__39R03","newsButtonBadge":"styles_newsButtonBadge__2ipC7"};